/**************************************************
 * Nombre:       Tarjetas_Citas_Tel
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import dayjs from "dayjs";
import es from "dayjs/locale/es";
import {combinarFechasHora} from "../../Modulo_formularios/Funciones/combinarFechasHora";


const Tarjetas_Citas_Tel = ({item, index, click}) => {
    dayjs.locale("es");


    return (
        <Grid
            onClick={() => click(item, index)}
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, borderColor: '#00000030', pr: 2, mt: 2, pb: 2}}
            spacing={0}
        >


            <Grid container size={12}>
                <Typography
                    sx={{
                        fontWeight: 600,
                        lineHeight: 1.1,
                        fontSize: 12
                    }}>{dayjs(combinarFechasHora({fecha: item.fecha, fechaHora: item.hora})).format('dddd MMM YYYY - HH:mm a').toUpperCase()}</Typography>
            </Grid>

            <Grid container size={12} sx={{mt: 0.5}} >
                <Typography
                    sx={{fontWeight: 300, lineHeight: 1.1, fontSize: 16}}>{`${item.notas}`}</Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjetas_Citas_Tel